export const errorAdapter = (error: any) => {
  console.log(error);
};
